import {ResolvedVisualComponent} from '@mintdata-wsp/common/state/ui/visualDesigner/artifacts/ResolvedVisualComponent';
import {Flow, FlowBlock} from '@mintdata-wsp/common/state/ui/visualDesigner/FlowState';
import {
    FrameComponentId,
    IVisualStreamId,
    VisualDataDirection,
    VisualStreamId
} from '@mintdata-wsp/common/state/ui/visualDesigner/visualData/VisualStreamIds';
import {
    VisualDataManager,
    VisualDataTimeline
} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataManager';
import {IVisualDataStreamer} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataStreamer';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {area} from '@mintdata/mint-kit/api/log/mk';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import {FrameMeta} from '@mintdata/mint-kit/api/values/frames/FrameMeta';

export class VisualDataController
{
    private static readonly _FIXED_NORTHBOUND_PORT_NAME = 'uiEvent';
    private _visualDataManager:VisualDataManager = new VisualDataManager();

    public clearAll(flow?:Flow):void
    {
        this._visualDataManager.clearCurrentSession(flow);
    }

    public getOrCreateTimeline(streamId:VisualStreamId):VisualDataTimeline
    {
        return this._visualDataManager.getOrCreateTimeline(streamId);
    }

    public getOrCreateStreamer(streamId:IVisualStreamId):IVisualDataStreamer
    {
        return this._visualDataManager.getOrCreateStreamer(streamId);
    }

    public getStreamer(streamId:IVisualStreamId):IVisualDataStreamer
    {
        return this._visualDataManager.getStreamer(streamId);
    }

    public onSouthboundFrame(frame:IFrame)
    {
        if( !this._isFrameValid(frame) )
            return;

        // console.log('onSouthboundFrame(): ', frame);
        // frame.print();

        this._visualDataManager.appendFrame(frame, VisualDataDirection.Southbound);
        // this._deliverSouthboundFrameToVisualComponent(frame);
    }

    public onNorthboundFrame(frame:IFrame, block:FlowBlock | null)
    {
        // if( !this._isFrameValid(frame) )
        //     return;
        //
        // // TODO: remove this check when we add proper debug panel support on the Surface tab
        // // (for UI events on a box that has not been 'Connect(ed) to Data' yet)
        // if( !block )
        //     return;
        //
        // // this._updateSimulationStatus();
        // this._visualDataManager.appendFrame(frame, VisualDataDirection.Northbound);
        //
        // const controller = controllers.ui.flowSimulation;
        // if( controller.canSendNorthboundEvents() )
        // {
        //     // noinspection JSIgnoredPromiseFromCall
        //     this._sendNorthboundFrameToCloud(block.id, frame);
        // }
    }

    // public _sendNorthboundFrameToCloud(flowBlockId:FlowBlockId, frame:IFrame):Promise<any>
    // {
    //     const controller = controllers.ui.simulation;
    //     const componentPortName = VisualDataController._FIXED_NORTHBOUND_PORT_NAME;
    //     const frameJsonObj:any = frame.toJSON();
    //     const topologyId = controller.getTopologyId();
    //
    //     const request = new SetVisualDataSimulationRequest(topologyId, flowBlockId, componentPortName, frameJsonObj);
    //
    //     return API.simulation.setVisualInput(request);
    // }

    private _deliverSouthboundFrameToVisualComponent(frame:IFrame):void
    {
        const {ui: {artifacts}} = controllers;
        const componentId:FrameComponentId = VisualStreamId.extractComponentId(frame);
        const visualLinkBlock = controllers.ui.flowCanvas.findBlock(componentId);

        if( visualLinkBlock.isDebugBlock )
            return;

        const box = controllers.ui.flowCanvas.findBoxFromBlockId(visualLinkBlock.id);

        if( !box )
            return;

        artifacts.resolveVisualComponent(box.component).then((rvc:ResolvedVisualComponent) =>
        {
            // const vci = rvc.getOrCreateInstance(box.id, box.getPropertiesAsJson());
            // TODO restore visual data delivery, when visual data is used again
            // vci.visualDataContext.deliverSouthboundFrame(frame);
        });
    }

    private _isFrameValid(frame):boolean
    {
        if( !frame )
        {
            console.warn(area.SSE, `VisualDataController: frame is undefined/null`);
            return false;
        }

        if( frame.isEmpty )
        {
            console.warn(area.SSE, `VisualDataController: frame is EMPTY`);
            return false;
        }

        const meta:FrameMeta = frame.getMeta();
        if( !meta )
        {
            console.warn(area.SSE, `VisualDataController: frame does not contain .meta(data)`);
            return false;
        }

        return true;
    }
}
